var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4627C0 19.3284 5.65476 25 12.5 25C19.3452 25 25 19.3284 25 12.4627C25 5.59702 19.3452 0 12.5 0C5.65476 0 0 5.59702 0 12.4627ZM17.1131 18.2836C14.2113 16.4925 10.4911 16.0448 6.17559 17.0149C5.13393 17.1642 4.98512 15.6716 5.87798 15.5224C10.6399 14.403 14.6577 14.9254 17.9315 16.9403C18.75 17.4627 17.9315 18.7313 17.1131 18.2836ZM18.378 14.9254C15.0298 12.8358 9.89583 12.2388 5.95238 13.4328C4.6875 13.806 4.24107 11.8657 5.43155 11.5672C9.97024 10.2239 15.5506 10.8955 19.4196 13.2836C20.4613 13.9552 19.4196 15.597 18.378 14.9254ZM5.35714 9.62687C4.09226 10.0746 3.27381 7.91045 4.6875 7.38806C9.07738 6.04478 16.5179 6.26866 21.131 9.02985C22.3958 9.70149 21.2054 11.791 19.8661 11.0448C15.8482 8.65672 9.15179 8.43284 5.35714 9.62687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.7bec3d0d.svg";
export { ForwardRef as ReactComponent };